import LazyHydration from 'components/LazyHydration';

import AdSenseSlot from '.';

const LazyHydratedAdSenseSlot = (props) => (
  <LazyHydration
    className={props.className}
    placeholderSize={{ height: props.height || 90 }}
  >
    <AdSenseSlot {...props} />
  </LazyHydration>
);

LazyHydratedAdSenseSlot.displayName = 'LazyHydratedAdSenseSlot';
LazyHydratedAdSenseSlot.propTypes = AdSenseSlot.propTypes;

export default LazyHydratedAdSenseSlot;
